var hamburger = document.querySelector('.hamburger'),
    menu = document.querySelector('.navigation'),
    header = document.querySelector('.header'),
    body = document.body

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
}

hamburger.addEventListener('click', toggleMenu);

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        var clickableArrow = document.createElement('span');

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu').classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.insertBefore(clickableArrow, element.querySelector('.submenu'));
    }
});
